import React, { useEffect, useState } from 'react'

import Axios from 'axios';
import FixtureTemplate from '../Fixture/FixtureTemplates/FixtureTemplate';

function FixturesLeagueByRound({leagueId}) {


    const [fixtures, setFixtures] = useState([]);
    const [round, setRound] = useState(1)

    useEffect(() => {



        async function fetchFixtures() {

            try {
                const response = await Axios({
                    "method":"GET",
                    "url":"https://api-football-v1.p.rapidapi.com/v2/fixtures/league/" + leagueId + "/Regular_Season_-_" + round,
                    "headers":{
                    "content-type":"application/octet-stream",
                    "x-rapidapi-host":"api-football-v1.p.rapidapi.com",
                    "x-rapidapi-key":"4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45",
                    "useQueryString":true
                    },"params":{
                    "timezone":"Europe/London"
                    }
                })
                console.log(response)
                if (response.data) {
                    setFixtures(response.data.api.fixtures)
                }
            } catch (error) {
                console.log(error)
            }


        }
        fetchFixtures()

    }, [leagueId, round])

    function roundChangeHandler(type) {
        if (type === "prev") {
            if (round > 1) {
                setRound(round-1);
            }
        }
        if (type === "next") {
            setRound(round+1)
        }
    }

    return (
        <div>
            <div className="card card-header">Kamper runde for runde (Runde {round})</div>

            <div className="row py-4">
                <div className="col-2 col-lg-1 text-center">
                    <div onClick={() => roundChangeHandler("prev")}>
                        <i className="fas fa-chevron-left pt-2"></i>
                    </div>
                    
                </div>
                <div className="col-8 col-lg-10 text-center">
                    <div className=" bg-white p-2">
                        Runde {round}
                    </div>                
                </div>
                <div className="col-2 col-lg-1">
                    <div onClick={() => roundChangeHandler("next")}>
                        <i className="fas fa-chevron-right pt-2"></i>
                    </div>
                </div>
            </div>

            {fixtures?.map((fixture, index) => {
                return (
                    <FixtureTemplate type="small" key={index} fixture={fixture} fixtureId={fixture.fixture_id} />
                )
            })}
        </div>
    )

}
export default FixturesLeagueByRound